export default __webpack_public_path__ + "static/media/NTEX CLASS-9 EXAM PATTERN 2026-27.c67b9c57.pdf";